// Configuration loader based on environment
import configDefault from './config.json'
import configLocal from './local.json'
import configDevelopment from './development.json'
import configProduction from './production.json'
import configQa from './qa.json'
import configStaging from './staging.json'

// REACT_APP_ENV can be set to override the environment
// NODE_ENV is 'development' when running npm start, 'production' for builds
const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development'

const configs = {
  local: configLocal,
  development: configDevelopment,
  production: configProduction,
  qa: configQa,
  staging: configStaging,
}

// Select config based on environment, fallback to default
const Config = configs[env] || configDefault

export default Config
